module.exports = __webpack_public_path__ + "img/brain.a4bf8717.png";